import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: null,
  data: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.userId = action.payload;
      state.isAuthenticated = true;
    },
    setUser: (state, action) => {
      state.data = action.payload;
    },
    removeUser: () => {
      return initialState;
    },
  },
});

export const { setUserId, setUser, removeUser } = authSlice.actions;

export default authSlice.reducer;
